import { State } from "@app/models/State";
import { States } from "@app/stateListing";
import { Property } from "@app/models/Property";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { Address } from "@app/models/Address";

/**
 * Created by mac85103 on 12/7/16.
 */
export class invalidAddressObj {
    line1Error: boolean;
    line2Error: boolean;
    unitNumberError: boolean;
    cityError: boolean;
    stateError: boolean;
    zipCodeError: boolean;
    zipCodeErrorMsg: string;
    line1Msg: string;
    propertyNicknameError: boolean;
    countryError: boolean;
}

export class AddressForm implements OnInit {
    @Input() property: Property;
    @Input() showPropertyNickname: boolean;
    @Input() showCountry: boolean;
    @Input() disableInputsAddress: boolean;
    @Input() isLoadingFindMyProperty: boolean;
    @Input() showEasyAddressInputs: boolean;
    @Input() setPropertyAddressEvent: Observable<void>;
    @Output() invalidCheck = new EventEmitter<any>();
    @Output() defaultNickname = new EventEmitter();
    @Output() blurFunction = new EventEmitter();

    invalidObj: invalidAddressObj;
    states: State[];
    addressFocusObj: any;
    disablePOBoxes: boolean = false;

    constructor() {
        this.setInvalidObj();
        this.resetFocus();
    }

    validateAddress() {
        this.line1();
        this.line2();
        this.unitNumber();
        this.city();
        this.state();
        this.zipCode();
        this.country();
        this.propertyNickname();
    }

    ngOnInit(): void {
        if(!this.property.address) {
            this.property.address = this.addressInit();
        }
        this.states = States.getStates();
        if (this.setPropertyAddressEvent)
            this.setPropertyAddressEvent.subscribe(() => this.validateAddress());
    }

    setInvalidObj() {
        this.invalidObj = {
            line1Error: false,
            line2Error: false,
            unitNumberError: false,
            cityError: false,
            stateError: false,
            zipCodeError: false,
            zipCodeErrorMsg: null,
            line1Msg: null,
            propertyNicknameError: false,
            countryError: false
        };
    }

    resetFocus() {
        this.addressFocusObj = {
            line1: false,
            line2: false,
            unitNumber: false,
            city: false,
            state: false,
            postalCode: false,
            propertyNickname: false,
            country: false
        };
    }

    line1() {
        let pattern = /\bP(ost)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)?\b/i;
        if (this.property.address.line1 === undefined) {
            this.invalidObj.line1Error = true;
            this.invalidObj.line1Msg = "Please enter your property address.";
        } else {
            if (this.property.address.line1) {
                if (this.disablePOBoxes && pattern.test(this.property.address.line1)) {
                    this.invalidObj.line1Error = true;
                    this.invalidObj.line1Msg = "PO Box address are not allowed."
                } else {
                    this.invalidObj.line1Error = false;
                    this.invalidObj.line1Msg = null;
                }
            } else {
                this.invalidObj.line1Error = true;
                this.invalidObj.line1Msg = "Please enter your property address.";
            }
        }
        this.defaultNickname.emit();
        this.propertyNickname();
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    line2() {
        //field is optional
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    unitNumber() {
        //field is optional
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    city() {
        if (this.property.address.city === undefined) {
            this.invalidObj.cityError = true;
        } else {
            this.invalidObj.cityError = !(this.property.address.city && this.valid(/\d|[a-zA-Z]/, this.property.address.city));
        }

        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    state() {
        if (this.property.address.state === undefined) {
            this.invalidObj.stateError = true;
        } else {
            this.invalidObj.stateError = !this.property.address.state;
        }
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    zipCode() {
        if (this.property.address.postalCode === undefined) {
            this.invalidObj.zipCodeError = true;
        } else {
            if (!this.showCountry) {
                this.invalidObj.zipCodeError = !this.property.address.postalCode;
                if (this.valid(/^[0-9]{5}$/, this.property.address.postalCode)) {
                    this.invalidObj.zipCodeError = false;
                    this.invalidObj.zipCodeErrorMsg = null;
                } else {
                    this.invalidObj.zipCodeError = true;
                    this.invalidObj.zipCodeErrorMsg = "Please enter a valid zip code.";
                }
            } else {
                this.invalidObj.zipCodeError = !this.property.address.postalCode;
                this.invalidObj.zipCodeErrorMsg = null;
            }
        }
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    propertyNickname() {
        if (this.addressFocusObj.propertyNickname) {
            if (this.property.nickname == null) {
                this.invalidObj.propertyNicknameError = true;
            } else {
                this.invalidObj.propertyNicknameError = !this.property.nickname;
            }
        } else {
            this.property.nickname = this.property.address.line1;
            this.invalidObj.propertyNicknameError = false;
        }
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    country() {
        if (this.addressFocusObj.country) {
            if (this.property.country == null) {
                this.invalidObj.countryError = true;
            } else {
                this.invalidObj.countryError = !this.property.country;
            }
        } else {
            this.invalidObj.countryError = false;
        }
        this.invalidCheck.emit({ invalidObj: this.invalidObj });
    }

    valid(pattern, value) {
        return pattern.test(value);
    }

    addressInit(): Address {
        return {
            line1: undefined,
            line2: undefined,
            unit: undefined,
            city: undefined,
            state: undefined,
            postalCode: undefined,
            country: undefined,
        }
    }
}

@Component({
    selector: 'app-address-form',
    template: require('./addressForm.directive.html')
})
export class AddressFormComponent extends AddressForm { }

@Component({
    selector: 'app-address-form-easy',
    template: require('./addressFormEasy.directive.html')
})
export class AddressFormEasyComponent extends AddressForm { }
